import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\node_modules\\next\\font\\google\\target.css?{\"path\":\"src\\\\components\\\\ContactForm\\\\ContactForm.js\",\"import\":\"Sour_Gummy\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"style\":[\"normal\",\"italic\"],\"display\":\"swap\"}],\"variableName\":\"sourGummy\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\krrsw\\development\\skylang\\src\\components\\CopyButton\\CopyButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\krrsw\\development\\skylang\\src\\components\\CourseItem\\CourseItems.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\krrsw\\development\\skylang\\src\\components\\Encouragement\\Encouragement.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\krrsw\\development\\skylang\\src\\components\\TallyForm\\TalllyForm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\krrsw\\development\\skylang\\src\\components\\Teachers\\Teachers.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\krrsw\\development\\skylang\\src\\components\\TeachingStyle\\TeachingStyle.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\krrsw\\development\\skylang\\src\\components\\Сertificate\\Сertificate.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\src\\styles\\components\\Intro.css");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\src\\styles\\components\\Services.css");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\src\\styles\\components\\Reviews.css");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\src\\styles\\components\\ContactForm.css");
